import React, { Component } from 'react';
import { ApiGetAwardRecords } from '@/api/index';
import { getProxyConfig } from '@/utils/utils';
import PriceMsg from '../map'
import dayjs from 'dayjs'
class PriceRecord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    }
  }

  getList() {
    const { app, appRules, appData } = this.props;
    ApiGetAwardRecords({
      headers: {
        ...appRules.header,
        ...appData,
      },
      data: {
        appId: appRules.appName,
      },
      ...getProxyConfig(app),
    }).then(res => {
      const { userAwardRecordList } = res
      if(['ipeso','xfectivo'].includes(app)) { // 更换时间格式
        userAwardRecordList.map((_) => {
            return _.expiredDate = dayjs(_.expiredDate).format('DD.MM.YYYY')
        })
      }
      this.setState({
        list: res.userAwardRecordList || []
      })
    })
  }

  componentDidMount() {
    this.getList();
  }

  render() {
    const { list } = this.state
    const { app } = this.props;

    const records = list.map((_, index) => {
      return <div className="price-box" key={ index }>
          <div className="content">
            <h3 className="content_name">{ _.awardDesc }</h3>
            <p className="content_date">{ _.expiredDate }</p>
          </div>
        </div>
    });
    return <div className="log-box prize-history">
      {/* <h2 className="log-box-title">{ ['ipeso','xfectivo'].includes(app) ? 'Récords de premios':'Prize Record' }</h2> */}
      <h2 className="log-box-title">{ (PriceMsg[app] && PriceMsg[app].prizeRecords) || PriceMsg['default'].prizeRecords }</h2>
      <div className="log-box-content">
        { records }
      </div>
    </div>
  }
}

export default PriceRecord;
